import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["questionKey"];
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { useEffect } from 'react';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { FullProductLineMap } from 'self-service-api/constants/ProductLineMap';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import { FaqsConfig } from '../../constants/faqs/FaqsConfig';
import { NavItemEnum } from '../../constants/routing/NavItems';
import Screens from '../../constants/routing/Screens';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { useFeatureStore } from '../../hooks/useFeatureStore';
import { useTrackRetail } from '../../hooks/useTrackRetail';
import Faq from '../faqs/Faq';
import FooterMicrocopy from '../faqs/FooterMicrocopy';
import Question from '../faqs/Question';
import { borderStyle, StyledCardGrid } from '../merch-card/MerchCardSharedComponents';
import ProductPageSubtitle from '../product-pages/ProductPageSubtitle';
import ProductPageTitle, { ProductPageHeader } from '../product-pages/ProductPageTitle';
import StarterCrmSuiteCtaCard from '../product-pages/StarterCrmSuiteCtaCard';
import MobileWrapperNoTabs from './containers/MobileWrapperNoTabs';
import MobileHighlightedFreeCard from './MobileHighlightedFreeCard';
import MobileSuiteFeatureTable from './MobileSuiteFeatureTable';
import MobileWhyGoHubSpotSection from './MobileWhyGoHubSpotSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MobileFreeToolsPage = () => {
  useDocumentTitle('crm');
  useTrackRetail();
  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: Screens.FREE
    });
  }, []);
  const marketingFreeProduct = FullProductLineMap[ProductLines.MARKETING].highlightedFreeProduct;
  useFeatureStore({
    highlightedProducts: marketingFreeProduct ? [marketingFreeProduct] : [],
    productLine: ProductLines.MARKETING
  });
  const salesFreeProduct = FullProductLineMap[ProductLines.SALES].highlightedFreeProduct;
  useFeatureStore({
    highlightedProducts: salesFreeProduct ? [salesFreeProduct] : [],
    productLine: ProductLines.SALES
  });
  const serviceFreeProduct = FullProductLineMap[ProductLines.SERVICE].highlightedFreeProduct;
  useFeatureStore({
    highlightedProducts: serviceFreeProduct ? [serviceFreeProduct] : [],
    productLine: ProductLines.SERVICE
  });
  const operationsFreeProduct = FullProductLineMap[ProductLines.OPERATIONS].highlightedFreeProduct;
  useFeatureStore({
    highlightedProducts: operationsFreeProduct ? [operationsFreeProduct] : [],
    productLine: ProductLines.OPERATIONS
  });
  const cmsFreeProduct = FullProductLineMap[ProductLines.CMS].highlightedFreeProduct;
  useFeatureStore({
    highlightedProducts: cmsFreeProduct ? [cmsFreeProduct] : [],
    productLine: ProductLines.CMS
  });
  const productsByProductLine = {
    [ProductLines.MARKETING]: [marketingFreeProduct],
    [ProductLines.SALES]: [salesFreeProduct],
    [ProductLines.SERVICE]: [serviceFreeProduct],
    [ProductLines.OPERATIONS]: [operationsFreeProduct],
    [ProductLines.CMS]: [cmsFreeProduct]
  };
  const commonStyles = {
    gridColumnStart: 1,
    paddingLeft: 28,
    paddingRight: 28,
    borderRight: borderStyle,
    borderLeft: borderStyle
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(MobileWrapperNoTabs, {
      navItem: NavItemEnum.FREE,
      navMarkerName: "FREE_TOOLS_PAGE",
      children: [/*#__PURE__*/_jsxs(ProductPageHeader, {
        children: [/*#__PURE__*/_jsx(ProductPageTitle, {
          nonProductIdentifier: NavItemEnum.FREE
        }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
          nonProductIdentifier: NavItemEnum.FREE
        })]
      }), /*#__PURE__*/_jsx(StyledCardGrid, {
        columns: 1,
        className: "m-bottom-4",
        children: /*#__PURE__*/_jsx(MobileHighlightedFreeCard, {
          productLine: "crm",
          commonStyles: commonStyles,
          perMonth: false
        })
      }), /*#__PURE__*/_jsx(MobileSuiteFeatureTable, {
        productLevel: FREE,
        productsByProductLine: productsByProductLine
      }), /*#__PURE__*/_jsx(MobileWhyGoHubSpotSection, {
        selectedNavItem: NavItemEnum.FREE
      }), /*#__PURE__*/_jsx(StarterCrmSuiteCtaCard, {
        productLine: "crm"
      }), /*#__PURE__*/_jsxs(Faq, {
        children: [FaqsConfig[NavItemEnum.FREE].map(_ref => {
          let {
              questionKey
            } = _ref,
            passthroughOptions = _objectWithoutPropertiesLoose(_ref, _excluded);
          return /*#__PURE__*/_jsx(Question, Object.assign({
            questionKey: questionKey
          }, passthroughOptions), questionKey);
        }), /*#__PURE__*/_jsx(FooterMicrocopy, {})]
      })]
    })
  });
};
export default MobileFreeToolsPage;